<template>
  <div class="invoice-container">
    <nav class="add-navigation mb-2">
        <div @click="$router.push({name: 'system-admin-vendor-list'})" class="back-link mr-sm-3">
          <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
            <path
              d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
              id="path-1"
            />
          </svg>
          <p>Back to Vendors</p>
        </div>
    </nav>

    <div class="selects-wrapper mb-3">
      <div class="d-flex  flex-wrap">
        <span class="filter_by filter_by_type pl-0 pr-3 my-1 white_space">Filter by type:</span>
        <primary-select
                type="text"
                class="choose-type my-1"
                @input="searchByVendorProduct"
                :value="selectedVendorProduct"
                :options="vendorProductOptions"
        />
      </div>
    </div>

    <div class="add-container">
      <span class="container-title">Rate deck</span>
      <div class="btns">
        <div class="smsc-btn" @click="EditRate">
          <primary-button>{{ is_editing_rate ? 'Save' : 'Edit Rate' }}</primary-button>
        </div>
        <div class="smsc-btn" @click="is_show_add_row = true">
          <primary-button>Add Rate</primary-button>
        </div>
      </div>
      <loader :loading="loading" v-if="loading" />
      <div v-else class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header header table-header">
              <th class="country" v-if="rateTable.rate_table_type === 'MNCMCC'">Country</th>
              <th class="code" v-else>Code</th>
              <th class="operator" v-if="rateTable.rate_table_type === 'MNCMCC'">Operator</th>
              <th class="rate">Rate</th>
              <th class="vendor">Vendor Product</th>
              <th class="action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="is_show_add_row">
              <template v-if="rateTable.rate_table_type === 'MNCMCC'">
                <th class="country-i">
                  <primary-select
                    v-model="selected.country_uuid"
                    @input="SelectCountry"
                  >
                    <option :value="null">Select Country</option>
                    <option
                      v-for="(i, country_uuid) in countries"
                      :key="country_uuid"
                      :value="i.country_uuid"
                    >{{i.nice_name ? i.nice_name : i.name}}</option>
                  </primary-select>
                </th>
                <th>
                  <primary-select
                    v-model="selected.mobile_net_uuid"
                    :options="mobile_networks"
                  />
                </th>
              </template>
              <template v-else>
                <th class="code-i">
                  <primary-input
                    style="padding-right: 0"
                    placeholder="Enter code"
                    v-model="selected.code"
                  />
                </th>
              </template>
              <th class="rate-i">
                <primary-input
                  style="padding-right: 0"
                  placeholder="Enter rate"
                  v-model="selected.rate"
                />
              </th>
              <th></th>
              <th class="action-i">
                <div class="btns">
                  <div class="smsc-btn" @click="AddRate">
                    <primary-button>Add</primary-button>
                  </div>
                  <div class="smsc-btn" @click="CloseAddRow">
                    <secondary-button>Cancel</secondary-button>
                  </div>
                </div>
              </th>
            </tr>
            <tr v-for="(rate, k) in getRates" :key="k">
              <th v-if="rateTable.rate_table_type === 'MNCMCC'" class="country-i">
                <div v-if="currentRate && currentRate.rate_uuid === rate.rate_uuid">
                  <primary-select
                    type="text"
                    name="country"
                    v-model="currentRate.code"
                    :class="{'input': true, 'is-danger': errors.has('country')}"
                    placeholder="Country"
                  >
                    <option
                      :value="i.country_uuid"
                      v-for="(i, country_uuid) in countries"
                      :key="country_uuid"
                    >{{i.nice_name ? i.nice_name : i.name}}</option>
                  </primary-select>
                  <div class="help is-danger" v-if="errors.has('did')">{{ errors.first('did') }}</div>
                  <div
                    class="help is-danger"
                    v-if="validateError"
                  >{{validateError.did ? validateError.did[0] : null}}</div>
                </div>
                <!-- <template v-else>{{rate.country_name}}</template> -->
                <template v-else>
                  <primary-select
                    v-model="rate.code"
                    @input="SelectCountry($event, rate)"
                    :disabled="!is_editing_rate"
                    :class="{ 'disabled': !is_editing_rate }"
                  >
                    <option
                      v-for="(i, country_uuid) in countries"
                      :key="country_uuid"
                      :value="i.country_uuid"
                    >{{i.nice_name ? i.nice_name : i.name}}</option>
                  </primary-select>
                </template>
              </th>
              <!-- <th v-else>{{ rate.code }}</th> -->
              <template v-else>
                  <primary-input
                    style="padding-right: 0"
                    v-model="rate.code"
                    :disabled="!is_editing_rate"
                    :class="{ 'disabled': !is_editing_rate }"
                  />
                </template>
              <!-- <th v-if="rateTable.rate_table_type === 'MNCMCC'">{{rate.mobile_network_name}}</th> -->
              <th v-if="rateTable.rate_table_type === 'MNCMCC'">
                <template v-if="!is_editing_rate">{{ rate.mobile_network_name }}</template>
                <primary-select
                  v-else
                  v-model="rate.mobile_network_uuid"
                  :options="rate.operators"
                  :disabled="!is_editing_rate"
                  :class="{ 'disabled': !is_editing_rate }"
                />
              </th>
              <th class="rate-i">
                <div v-if="currentRate && currentRate.rate_uuid === rate.rate_uuid">
                  <primary-input
                    v-if="currentRate && currentRate.rate_uuid === rate.rate_uuid"
                    type="text"
                    name="rate"
                    v-model="currentRate.price"
                    v-validate="'required'"
                    :class="{'input': true, 'is-danger': errors.has('rate')}"
                    placeholder="Enter rate"
                  />
                  <div class="help is-danger" v-if="errors.has('rate')">{{ errors.first('rate') }}</div>
                  <div
                    class="help is-danger"
                    v-if="validateError"
                  >{{validateError.rate ? validateError.rate[0] : null}}</div>
                </div>
                <!-- <template v-else>{{rate.price}}</template> -->
                <template v-else>
                  <primary-input
                    style="padding-right: 0"
                    v-model="rate.price"
                    :disabled="!is_editing_rate"
                    :class="{ 'disabled': !is_editing_rate }"
                  />
                </template>
              </th>
              <th>
                <div v-if="currentRate && currentRate.rate_uuid === rate.rate_uuid">
                  <primary-select
                    v-if="currentRate && currentRate.rate_uuid === rate.rate_uuid"
                    type="text"
                    name="vendor product"
                    v-validate="'required'"
                    v-model="currentRate.rate_table_uuid"
                    :class="{'input': true, 'is-danger': errors.has('vendor product')}"
                    placeholder="Type"
                  >
                    <option
                      v-for="(vendorProduct, i) in vendorProducts"
                      :key="i"
                      :value="vendorProduct.rate_table_uuid"
                    >{{vendorProduct.vendor_product_name}}</option>
                  </primary-select>
                  <div
                    class="help is-danger"
                    v-if="errors.has('vendor product')"
                  >{{ errors.first('vendor product') }}</div>
                  <div
                    class="help is-danger"
                    v-if="validateError"
                  >{{validateError.vendor_product ? validateError.vendor_product[0] : null}}</div>
                </div>
                <template v-else>{{rate.vendor_product_name}}</template>
              </th>
              <th>
                <svg
                  @click="deleteRate(rate.rate_uuid)"
                  class="svg-grey"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <path
                    d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                    id="path-1"
                  />
                </svg>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="per-page">
        <span class="filter_by custom-row">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
          </primary-select>
        </div>
      </div>
      <div class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="totalPage"
          :perPage="per_page"
          :qnt="getRates.length"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    AppDropdown: () => import("@/components/DropDowns/Dropdown.vue"),
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    validateError: null,
    Page: 0,
    Searched: null,
    currentRate: null,
    vendorProductTypes: [
      { name: "Prefix", value: "prefix" },
      { name: "MNCMCC", value: "MNCMCC" },
    ],
    vendorProductType: "prefix",
    selectedVendorProduct: null,
    rateId: null,
    countries: [],
    isEditAction: false,
    per_page: 10,
    pages: [10, 50, 100],
    loading: false,

    is_show_add_row: false,
    is_editing_rate: false,

    mobile_networks: [],

    selected: {
      country_uuid: null,
      mobile_net_uuid: null,
      rate: null,
      code: null
    },

    payload: {
      rate_table_type: null,
      rates: []
    }
  }),
  watch: {
    "currentRate.code": function () {
      if (!this.currentRate) {
        return;
      }
      
      this.getMobileNetworkList(this.currentRate.code);
    },
  },
  computed: {
    ...mapGetters({
      getRates: "rates/getRates",
      totalPage: "rates/getTotalPages",
      vendorProducts: "vendorProduct/getVendorProducts",
      totalVendorProducts: "vendorProduct/getTotal",
      mobileNetworks: "mobileNetwork/getMobileNetworkList",
      mobileNetworksTotal: "mobileNetwork/getTotal",
      rateTable: "rateTable/getRateTable",
    }),
    vendorProductOptions() {
      return this.vendorProducts.map((item) => ({
        name: item.vendor_product_name,
        value: item.vendor_product_uuid,
      }));
    }
  },
  async created() {
    this.vendorId = this.$route.params.id;
    this.getRateList();
    this.getCountryList();
    await this.getAllVendorProducts();
    if (this.vendorProducts[0]) {
      this.searchByVendorProduct(this.vendorProducts[0].vendor_product_uuid);
    }
  },
  methods: {
    ...mapActions({
      viewAllRates: "rates/getRateList",
      delete: "rates/deleteRate",
      viewVendorProducts: "vendorProduct/getVendorProductList",
      addRate: "rates/addRate",
      edit: "rates/editRate",
      viewMobileNetworks: "mobileNetwork/GetMobileNetworks",
      viewRateTable: "rateTable/getRateTable",
    }),
    SetOperator() {
      if (this.rateTable.rate_table_type === 'prefix') {
        return
      }

      this.loading = true
      const promises = []
      this.getRates.forEach(item => {
        promises.push(this.SelectCountry(item.code))
      })
      Promise.all(promises).then(res => {
        this.getRates.forEach((item, index) => {
          item.operators = res[index]
        })
        this.loading = false
      })
    },
    async SelectCountry(e, elem) {
      const params = {
        page: 0,
        per_page: 0,
        country_code: e
      }
      const { total } = await this.$store.dispatch('mobileNetwork/GetMobileNetworksNoCommit', params)
      const { items } = await this.$store.dispatch('mobileNetwork/GetMobileNetworksNoCommit', { ...params, per_page: total })

      if (elem) {
        elem.operators = [...items.map(this.TransformMobileNetwork)]
        elem.mobile_network_uuid = elem.operators[0].value
        console.log(elem)
      }
      this.mobile_networks = items.map(this.TransformMobileNetwork)
      this.selected.mobile_net_uuid = this.mobile_networks[0] && this.mobile_networks[0].value
      return this.mobile_networks
    },
    AddRate() {
      this.payload.rate_table_type = this.rateTable.rate_table_type

      if (this.rateTable.rate_table_type === 'prefix') {
        // prefix type
        this.payload.rates = this.getRates.map(this.TransformPrefixRate)
        const rate = {
          code: this.selected.code,
          price: this.selected.rate
        }
        this.payload.rates.push(rate)
      } else {
        // MNCMCC type
        this.payload.rates = this.getRates.map(this.TransformRate)
        const rate = {
          code: this.selected.country_uuid,
          mobile_network_uuid: this.selected.mobile_net_uuid,
          price: this.selected.rate
        }
        this.payload.rates.push(rate)
      }

      this.$store.dispatch('rateTable/editRateTable', { rate_table_uuid: this.rateTable.rate_table_uuid, data: this.payload})
      .then(res => {
        if (res.rates.length) {
          this.$snotify.success('Rates has been added', { timeput: 6000 })
          this.CloseAddRow()
          this.getRateList()
        }
      })
      .catch(err => {
        this.$snotify.error(err, { timeput: 6000 })
      })
    },
    CloseAddRow() {
      this.is_show_add_row = false
      this.is_editing_rate = false
      this.payload.rate_table_type = null,
      this.payload.rates = []
      
      // Clear selected data
      for (let item in this.selected) {
        this.selected[item] = null
      }
    },
    EditRate() {
      if (this.is_editing_rate) {
        // calling API and end editing
        this.EndEditingRate()
      } else {
        // start editing
        this.StartEditingRate()
      }
    },
    StartEditingRate() {
      this.is_editing_rate = true
      this.SetOperator()
    },
    TransformPrefixRate(item) {
      return {
        code: item.code,
        price: item.price
      }
    },
    TransformRate(item) {
      return {
        code: item.code,
        price: item.price,
        mobile_network_uuid: item.mobile_network_uuid
      }
    },
    EndEditingRate() {
      const payload = {
        rates: [],
        rate_table_type: this.rateTable.rate_table_type
      }
      if (this.rateTable.rate_table_type === 'prefix') {
        payload.rates = this.getRates.map(this.TransformPrefixRate)
      } else {
        payload.rates = this.getRates.map(this.TransformRate)
      }
      this.$store.dispatch('rateTable/editRateTable', { rate_table_uuid: this.rateTable.rate_table_uuid, data: payload})
      .then(res => {
        if (res.rates.length) {
          this.is_editing_rate = false
          this.$snotify.success('Rates has been edited', { timeput: 6000 })
          this.getRateList()
        }
      })
      .catch(err => {
        this.$snotify.error(err, { timeput: 6000 })
      })
    },
    changePerPage() {
      this.Page = 0;
      this.getRateList();
    },
    changePage(page) {
      this.Page = page;
      this.getRateList();
    },
    async searchByVendorProduct(v) {
      this.CloseAddRow()
      this.selectedVendorProduct = v;

      const vendorProduct = this.vendorProducts.filter(
        (item) => item.vendor_product_uuid === v
      );

      const { rate_table_uuid } = vendorProduct[0];

      await this.viewRateTable(rate_table_uuid);

      this.getRateList();
    },
    async getRateList() {
      await this.viewAllRates({
        page: this.Page,
        vendor_uuid: this.$route.params.id,
        vendor_product_uuid: this.selectedVendorProduct || null,
        per_page: this.per_page,
      });
    },
    async getCountryList() {
      const { items } = await this.$store.dispatch("getCountryList", {});
      this.countries = items;
    },
    async getAllVendorProducts() {
      await this.viewVendorProducts({ vendorId: this.vendorId });
      await this.viewVendorProducts({
        perPage: this.totalVendorProducts,
        vendorId: this.vendorId,
      });
    },
    async getMobileNetworkList(id) {
      await this.viewMobileNetworks({ country_code: id });
      await this.viewMobileNetworks({
        country_code: id,
        per_page: this.mobileNetworksTotal,
      });
    },
    deleteRate(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this vendor!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.delete(id)
            .then(() => {
              this.$swal("Deleted!", "Your rate has been deleted.", "success");
            })
            .catch((err) => {
              this.$snotify.error(err.response.data);
            });
        }
      });
    },
    TransformMobileNetwork(item) {
      return {
        name: item.network_name,
        value: item.mobile_network_uuid
      }
    }
  },
};
</script>

<style lang="scss">
.invoice-container {
  padding: 0 20px;

  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 25px;
      p {
        margin-bottom: 0;
      }
    }
    .primary-button {
      width: 160px;
    }
  }

  .selects-wrapper {
     display: flex;
     align-items: center;
     width: fit-content;
     .filter_by {
       color: #55616e;
       font-weight: normal;
       font-family: "Helvetica Neue";
       font-size: 14px;
       line-height: 25px;
     }
     .filter_by_type {
       white-space: nowrap;
     }
     .choose-type {
       height: 40px;
       width: 250px;
       margin: 0 15px 0px 0;
       color: #55616e;
       font-weight: normal;
     }
   }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    .primary-button {
      height: 40px;
      width: 130px;
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    // height: 390px;
    background-color: #ffffff;
    padding: 15px 20px 0;

    .btns {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .smsc-btn {
        margin-left: 20px;

        &:first-child {
          margin-left: 0;
        }
      }
    }
    .container-title {
      height: 30px;
      width: 432px;
      color: #212529;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 5px 0;
      font-family: "Helvetica Neue";
    }
  }
  .help {
    margin-top: 10px;
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;

  input {
    text-align: center;
  }
  select {
    text-align-last: center;
  }
  .disabled {
    
    input {
      border: none !important;
      color: #212b36 !important;
      text-align: center;
      opacity: 1 !important;
    }
    select {
      border: none !important;
      color: #212b36 !important;
      opacity: 1;
      text-align-last: center;

      & ~ img {
        display: none;
      }
    }
    div {
      border: none !important;
    }
  }

  th {
    height: 44px;
    text-align: center;
  }
  .country {
    min-width: 150px;
  }
  .country-i {
    min-width: 260px;
  }
  .code {
    min-width: 150px;
  }
  .code-i {
    min-width: 200px;
  }
  .operator {
    min-width: 380px;
  }
  .rate {
    min-width: 100px;
  }
  .rate-i {
    min-width: 200px;
  }
  .vendor {
    min-width: 160px;
  }
  .action {
    width: 90px;
    padding-left: 0;
    // padding-right: 0;
  }
  .action-i {
    width: 185px;
  }
  .table-header th {
    padding-left: 0px;
    border: 1px solid #dee2e6;
    background: #51a3f3;
    color: #fff;
  }
}
table thead tr {
  height: 37px;
  //background: #F8F9FE;
  text-align: left;
}
table,
tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_header th {
  height: 16px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  padding: 11px 0 10px 0;
}
tbody th {
  .primary-input-container {
    padding-right: 10px;
    // margin-top: 20px;
    .pimary-input-title {
      display: none !important;
    }
    .primary-input {
      padding-right: 10px;
    }
  }
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  padding: 13px 10px;
  text-align: left;
}
table thead th:first-child {
  padding-left: 35px;
}
tbody th.icon {
  height: 44px;
  float: right;
  margin: 0 auto;
  padding: 7px 0;
  .svg-grey {
    fill: #55616e;
    height: 30px;
    width: 30px;
  }
}

.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}

// @media screen and (max-width: 1250px) {
//   table.Invoice_table {
//     width: 1100px;
//   }
// }
</style>

